import { useQuery } from '@apollo/client';

import mergeConnectionResultsBy from 'common/graphql/mergeConnectionResultsBy';
import { isFetchingMore } from 'common/graphql/networkStatus';
import useCompanyContext from 'common/hooks/useCompanyContext';

import { ScheduledTransfersDocument } from './scheduledTransfers.gql';

export const MAX_ITEMS_NUMBER = 100;

const mergeScheduledTransfersConnectionResult = mergeConnectionResultsBy(
  'scheduledBankTransferId',
);

export function useScheduledTransfers() {
  const { companyProfileId } = useCompanyContext();

  const {
    data,
    error,
    fetchMore: apolloFetchMore,
    loading,
    networkStatus,
    refetch,
  } = useQuery(ScheduledTransfersDocument, {
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    skip: !companyProfileId,
    variables: {
      after: null,
      companyProfileId: companyProfileId as string,
      first: MAX_ITEMS_NUMBER,
    },
  });

  const { endCursor, hasNextPage } =
    data?.viewer.scheduledBankTransfers.pageInfo ?? {};

  const scheduledBankTransferEdges =
    data?.viewer.scheduledBankTransfers.edges ?? [];

  const scheduledBankTransfers = scheduledBankTransferEdges.map(
    (edge) => edge.node,
  );

  const fetchMore = () =>
    apolloFetchMore({
      updateQuery: (previousResult, { fetchMoreResult }) =>
        mergeScheduledTransfersConnectionResult(
          previousResult,
          fetchMoreResult,
        ),
      variables: { after: endCursor, first: MAX_ITEMS_NUMBER },
    });

  return {
    error,
    fetchMore,
    hasNextPage,
    isFetchingMore: isFetchingMore(networkStatus),
    loading,
    refetch,
    scheduledTransfers: scheduledBankTransfers,
  };
}
